import React, { FC } from 'react';
import AtsNoticeBanner from '@components/position/jd/noticeBanner/AtsNoticeBanner';
import CmsNoticeBanner from '@components/position/jd/noticeBanner/CmsNoticeBanner';
import { PositionApplyType } from '@domain/constant/PositionApplyType';

interface NoticeBannerProps {
  companyName: string;
  applyType: PositionApplyType;
}

const NoticeBanner: FC<NoticeBannerProps> = ({ companyName, applyType }) => {
  switch (applyType) {
    case 'INSIGHT':
    case 'ATS':
      return <AtsNoticeBanner companyName={companyName} />;
    case 'CMS':
      return <CmsNoticeBanner companyName={companyName} />;
  }

  return <></>;
};

export default NoticeBanner;
